<template>
    <v-form ref="petDemographicForm" v-model="currentPetDemographic.isValid">
        <!--<img v-if="archimedes" src="@/assets/cat.gif" id="archimedes" />-->
        <v-container class="py-0 py-sm-0">
            <v-row>
                <v-col class="pl-10 py-0 py-sm-0" style="min-height: 445px; overflow-y: hidden!important;" v-if="animals.length > 0 && !addNewAnimal">
                    <v-row>
                        <v-col class="col-9 pl-10 py-0 py-sm-0">
                            <label for="pets">Pets</label>
                            <v-autocomplete v-model="$store.state.ezyvet.animal"
                                            v-on:change="assignAminal()"
                                            :items="animals"
                                            label="Either choose or add your pet"
                                            item-text="name"
                                            background-color="white"
                                            outlined
                                            solo
                                            return-object>
                            </v-autocomplete>
                        </v-col>
                        <v-col class="col-2 pl-1 py-0 py-sm-0" style="margin-top: 22px;">
                            <v-btn raised fab class="elevation-5 v-size--small" v-on:click="createNewAnimal()">
                                <v-icon style="font-size: 20px;">mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pl-10 py-0 py-sm-0" style="min-height: 445px; overflow-y: hidden!important;" v-else>
                    <span v-if="animals.length > 0" v-on:click="backToPetList()"><a>&lt; Back to Pets list</a></span>
                    <div class="form-group mb-6" v-if="currentModel.settings.walkInShowPetName">
                        <label for="Pet name">Pet Name</label>
                        <!--{{ currentModel.settings.localizedContent['reservation_pet_name_label'] }}-->
                        <v-text-field v-model="currentPetDemographic.formData.petName"
                                      name="PetName"
                                      background-color="white"
                                      id="petName"
                                      ref="petName"
                                      class="mt-1"
                                      autocomplete="off"
                                      :rules="petNameRules"
                                      solo
                                      outlined
                                      validate-on-blur>
                        </v-text-field>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.petName" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetSpeciesGeneral">
                        <label for="species">{{ currentModel.settings.localizedContent['reservation_pet_species_general_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.species"
                                  :items="speciesList"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="species"
                                  id="species"
                                  ref="species"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.species" color="secondary">mdi-check</v-icon>
                    </div>
                <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetBreed">
                    <div>
                        <label for="petBreed">{{ currentModel.settings.localizedContent['reservation_pet_breed_label'] }}</label>
                    </div>
                    <v-select v-model="currentPetDemographic.formData.petBreed"
                              :items="petBreedList"
                              :allow-overflow="false"
                              class="mt-1"
                              name="petBreed"
                              id="petBreed"
                              ref="petBreed"
                              background-color="white"
                              outlined>
                    </v-select>
                    <v-icon class="input-valid" v-if="currentPetDemographic.formData.petBreed" color="secondary">mdi-check</v-icon>
                </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.showWalkInPetColor">
                        <label for="petColor">{{ currentModel.settings.localizedContent['reservation_pet_color_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.petColor"
                                  :items="petColorList"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="petColor"
                                  id="petColor"
                                  ref="petColor"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.petColor" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.petAgeInputType === 'CALENDER_DATE'">
                        <label for="petApproxAge">{{ currentModel.settings.localizedContent['reservation_approx_age_label'] }}</label>
                        <v-text-field v-facade="'##/##/####'"
                                      v-model="currentPetDemographic.formData.petApproxAge"
                                      name="PetApproxAge"
                                      type="text"
                                      class="mt-1"
                                      id="petApproxAge"
                                      ref="petApproxAge"
                                      background-color="white"
                                      autocomplete="off"
                                      :rules="petApproxCalenderAgeAgeRules"
                                      placeholder="MM/DD/YYYY"
                                      solo
                                      outlined
                                      validate-on-blur>
                        </v-text-field>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.petApproxAge" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.petAgeInputType === 'PICKLIST'">
                        <label for="petApproxAge">{{ currentModel.settings.localizedContent['reservation_approx_age_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.petApproxAge"
                                  :items="currentModel.settings.approximateAgeValues"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="approxAge"
                                  id="petApproxAge"
                                  ref="petApproxAge"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.petApproxAge" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mb-6" v-if="currentModel.settings.petAgeInputType === 'FREE_TEXT'">
                        <label for="petApproxAge">{{ currentModel.settings.localizedContent['reservation_approx_age_label'] }}</label>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="currentPetDemographic.formData.petApproxAge"
                                              name="petApproxAge"
                                              background-color="white"
                                              id="petApproxAge"
                                              ref="petApproxAge"
                                              class="mt-1"
                                              autocomplete="off"
                                              :rules="petApproxAgeRules"
                                              solo
                                              outlined
                                              validate-on-blur>
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-select v-model="currentPetDemographic.formData.petApproxAgeType"
                                          :items="currentModel.settings.approximateAgeTypes"
                                          :allow-overflow="false"
                                          class="mt-1"
                                          name="petApproxAgeType"
                                          id="petApproxAgeType"
                                          ref="petApproxAgeType"
                                          background-color="white"
                                          outlined>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.petApproxAge" color="secondary">mdi-check</v-icon>
                    </div>
                    <div class="form-group mt-6">
                        <label style="display: block;">{{ currentModel.settings.localizedContent['reservation_pet_gender_label'] }}</label>
                        <v-select v-model="currentPetDemographic.formData.sex"
                                  :items="petGendersList"
                                  :allow-overflow="false"
                                  class="mt-1"
                                  name="PetGender"
                                  id="petGender"
                                  ref="petGender"
                                  background-color="white"
                                  outlined>
                        </v-select>
                        <v-icon class="input-valid" v-if="currentPetDemographic.formData.sex" color="secondary" style="top: -70px; left: -37px;">mdi-check</v-icon>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import moment from 'moment';
    import ContextualMixin from '../mixins/contextualMixin'
    import WalkinFormMixin from '../mixins/walkinFormMixin'

    export default {
        name: 'Demographic',
        mixins: [ContextualMixin, WalkinFormMixin],
        data() {
            return {
                petNameRules: [
                    v => !!v || 'Pet name is required',
                    v => /^[a-zA-Z0-9 '-.´]+$/.test(v) || 'Pet name is invalid.',
                    v => isNaN(v) || 'Pet name is invalid'
                ],
                petColorRules: [
                    v => !!v || 'Pet color is required'
                ],
                petApproxAgeRules: [
                    v => !isNaN(v) || 'Age should be numeric'
                ],
                petApproxFreeTextAgeRules: [
                    v => !!v || 'Date of birth is required',
                    v => moment(v, 'MM/DD/YYYY', true).isValid() || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', false) < 120 || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', true) > 0 || 'Date of birth is invalid',
                    v => moment(v, 'MM/DD/YYYY', true).years() > 1000 || 'Date of birth is invalid',
                ],
                petApproxCalenderAgeAgeRules: [
                    v => !!v || 'Date of birth is required',
                    v => moment(v, 'MM/DD/YYYY', true).isValid() || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', false) < 120 || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', true) > 0 || 'Date of birth is invalid',
                    v => moment(v, 'MM/DD/YYYY', true).years() > 1000 || 'Date of birth is invalid',
                ],
            }
        },
        computed: {
            addNewAnimal() {
                return this.$store.state.ezyvet.addNewAnimal;
            },
            animals() {
                return this.$store.state.ezyvet.animals;
            },
            speciesList() {
                if (!this.$store.state.currentModel.settings.ezyvetSpecies) return [];
                    return this.$store.state.currentModel.settings.ezyvetSpecies.map(x => x.name);
            },
            petBreedList() {
                if (!this.$store.state.currentPetDemographic.formData.species) return [];

                let tis = this;
                let speciesId = this.$store.state.currentModel.settings.ezyvetSpecies.filter(x => x.name === tis.$store.state.currentPetDemographic.formData.species)[0].speciesId;
                return this.$store.state.currentModel.settings.ezyvetBreeds.filter(x => x.speciesId === speciesId)
                    .map(x => x.name);

                //if (!this.$store.state.currentModel.settings.ezyvetBreeds) return [];
                //    return this.$store.state.currentModel.settings.ezyvetBreeds.map(x => x.name);
            },
            petColorList() {
                if (!this.$store.state.currentModel.settings.ezyvetPetColors) return [];
                    return this.$store.state.currentModel.settings.ezyvetPetColors.map(x => x.name);
            },
            petGendersList() {
                if (!this.$store.state.currentModel.settings.ezyvetGenders) return [];
                    return this.$store.state.currentModel.settings.ezyvetGenders.map(x => x.name);
            },
            currentPetDemographic() {
                return this.$store.state.currentPetDemographic;
            },
            currentPetDemographicRef() {
                return this.$refs.petDmographicForm;
            },
            petNameValid() {
                if (!this.currentPetDemographic.formData.petName || !this.$refs.petName)
                    return false;
                return this.$refs.petName.validate();
            },
            petBreedValid() {
                if (!this.currentPetDemographic.formData.petBreed || !this.$refs.petBreed)
                    return false;
                return this.$refs.petBreed.validate();
            },
            petColorValid() {
                if (!this.currentPetDemographic.formData.petColor || !this.$refs.petColor)
                    return false;
                return this.$refs.petColor.validate();
            },
            approxAgeValid() {
                if (!this.currentPetDemographic.formData.petApproxAge || !this.$refs.petApproxAge)
                    return false;
                return this.$refs.petApproxAge.validate();
            },
            approxAgeCalenderDateValid() {
                if (!this.currentPetDemographic.formData.petApproxAge || !this.$refs.petApproxAge)
                    return false;
                return true;
            }
        },
        methods: {
            assignAminal() {
                const animal = this.$store.state.ezyvet.animal;
                const settings = this.$store.state.currentModel.settings;
                const demographics = {
                    species: (settings.ezyvetSpecies ?? []).filter(x => x.speciesId == animal.speciesId)[0]?.name,
                    petBreed: (settings.ezyvetBreeds ?? []).filter(x => x.breedId == animal.breedId)[0]?.name,
                    petColor: (settings.ezyvetPetColors ?? []).filter(x => x.colorId == animal.animalcolourId)[0]?.name,
                    sex: (settings.ezyvetGenders ?? []).filter(x => x.genderId == animal.sexId)[0]?.name,
                    petName: animal.name,
                    animalId: animal.id,
                    petApproxAge: animal.dob,
                }
                this.$store.state.currentPetDemographic = {
                    formData: demographics,
                    isValid: true
                }
                console.log(this.$store.state.currentPetDemographic);
                this.$store.state.ezyvet.addNewAnimal = true;
            },
            createNewAnimal() {
                this.$store.state.currentPetDemographic = {
                    formData: {},
                    isValid: false
                }
                this.$store.state.ezyvet.addNewAnimal = true;
            },
            backToPetList() {
                this.$store.state.ezyvet.animal = null;
                this.$store.state.ezyvet.addNewAnimal = false;
            }
        },
        watch: {
            'currentPetDemographic.formData.petName': function (v) {
                if (!v || !v.length)
                    return;
                let fn = this.$store.state.currentPetDemographic.formData.petName;
                if (v.charAt(0) !== v.charAt(0).toUpperCase())
                    this.$store.state.currentPetDemographic.formData.petName =
                        fn.charAt(0).toUpperCase() + fn.slice(1);
            }
        }
    }
</script>
<style>
    #archimedes {
        position: fixed;
        bottom: 15px;
        left: -50%;
        z-index: 1;
        animation: run 4s infinite normal linear;
    }

    @-webkit-keyframes run {
        0% {
            left: -50%;
        }

        100% {
            left: 100%;
        }
    }

    @keyframes run {
        0% {
            left: -50%;
        }

        100% {
            left: 100%;
        }
    }
</style>